import { createContext } from "react";
import { IRoleContext } from "./types";

const defaultValue: IRoleContext = {
  role: undefined,
  setRole: () => {},
  saveChanges: () => {},
  cancelChanges: () => {},
  isLoading: false,
  isValid: false,
  isModified: false,
};

const context = createContext<IRoleContext>(defaultValue);

export default context;
